import { CommonPerm } from "@enum/common/permission/common-perm.enum";
import { AdministrativeSection } from "./administrative.section";
import { LinkRoutes } from "@enum/central/link-routes.enum";
import { ConfigurationSection } from "./configuration.section";
import { CentralPerm } from "@enum/central/central-perm.enum";
import { SalesSection } from "./sales.section";
import { GovernanceSection } from "./governance.section";

export const centralMenu = [
  {
    title: 'Início',
    root: true,
    icon: 'home',
    page: LinkRoutes.DASHBOARD,
    bullet: 'dot',
  },
  ...AdministrativeSection,
  ...SalesSection,
  {
    section: 'Produto',
    permission: ['*', CentralPerm.Releases_View],
  },
  {
    title: 'Versões',
    root: true,
    icon: 'campaign',
    page: LinkRoutes.LIST_RELEASES,
    permission: ['*', CentralPerm.Releases_View],
    bullet: 'dot',
  },
  {
    section: 'Suporte',
    permission: ['*', CentralPerm.Tickets_View],
  },
  {
    // Suporte enterprise (26/09/2026, spec §4.4/§7): 5 telas novas
    // (Respostas prontas, Incidentes, Indicadores, Configurações, além da
    // Fila) pedem submenu, no mesmo formato de `tenant/administrative.
    // section.ts:46` ("Pessoas"). O badge de chamados em aberto muda de
    // dono: sai do pai (que agora é só o grupo) e vai para "Fila de
    // atendimento", que é quem o item de menu realmente representa.
    title: 'Suporte',
    root: true,
    icon: 'support_agent',
    permission: ['*', CentralPerm.Tickets_View],
    bullet: 'dot',
    submenu: [
      {
        title: 'Fila de atendimento',
        root: true,
        page: '/admin/chamados',
        permission: ['*', CentralPerm.Tickets_View],
        badge: 'support',
        bullet: 'dot',
      },
      {
        title: 'Respostas prontas',
        root: true,
        page: '/admin/chamados/respostas-prontas',
        permission: ['*', CentralPerm.Tickets_View],
        bullet: 'dot',
      },
      {
        title: 'Incidentes',
        root: true,
        page: '/admin/chamados/incidentes',
        permission: ['*', CentralPerm.Tickets_View],
        bullet: 'dot',
      },
      {
        title: 'Indicadores',
        root: true,
        page: '/admin/chamados/indicadores',
        permission: ['*', CentralPerm.Tickets_View],
        bullet: 'dot',
      },
      {
        title: 'Configurações',
        root: true,
        page: '/admin/chamados/configuracoes',
        permission: ['*', CentralPerm.Tickets_View],
        bullet: 'dot',
      },
    ],
  },
  ...ConfigurationSection,
  ...GovernanceSection,
  { section: '.' },
  { section: '.' },
  { section: '.' },
  { section: '.' },
  { section: '.' },
  { section: '.' },
  { section: '.' },
  { section: '.' },
  {
    section: 'Histórico',
    permission: ['*', CommonPerm.Logs_View],
  },
  {
    title: 'Ações',
    permission: ['*', CommonPerm.Logs_View],
    root: true,
    icon: 'menu_book',
    bullet: 'dot',
    page: '/admin/historicos/acoes',
  },
  { section: '.' },
  { section: '.' },
];
